/* @flow */

import fetch from 'utils/fetch';

export const upload = (folderId, file) => {
  const data = new FormData();
  data.append('attachment', file);

  return fetch(`/bucket/folders.json/${folderId}/upload`, {
    method: 'POST',
    body: data,
  }).then(res => res.json());
};

export const crop = (
  folderId: string,
  resourceId: string,
  config: CropConfig
) =>
  fetch(`/bucket/folders.json/${folderId}/crop/${resourceId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(config),
  }).then(res => res.json());



// WEBPACK FOOTER //
// ./src/modules/bucket/api/uploads.js